import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { read } from "xlsx";
import dayjs from "dayjs";
import {
  Radio,
  Checkbox,
  Tooltip,
  Stack,
  FormLabel,
  Input,
  Grid,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Button,
  Card,
  RadioGroup,
  FormControlLabel,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  ListItemText,
  Box,
  Typography,
  IconButton as MuiIconButton,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import DownloadIcon from "@mui/icons-material/DownloadOutlined";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import FilterListIcon from "@mui/icons-material/FilterList";
import {
  DataGrid,
  GridToolbarContainer,
  GridActionsCellItem,
} from "@mui/x-data-grid";
import { useSelector } from "react-redux";
import format from "date-fns/format";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import ViewIcon from "@mui/icons-material/Visibility";
import { toast } from "react-toastify";
import { CommonButton } from "../common/commonButton";
import { useStyles } from "./paymentUpdatesContainerStyles";
import { CommonPaginationContainer, CommonFilterSidebar } from "../common";
import { } from "../../utils/generalFunctions";
import instance from "../../redux/api";
import { premiumBDX, exceptionReport, premiumBDXFile, premiumBDXReadData } from "../../Services/api";
import DialogBox from "../common/dialog";
import CustomDateRangePicker from "../common/CustomDateRangePicker";
import GetViewTable from "./GetViewTable";
import { getPaginationCount } from "../CashAllocation/utils";
import { CustomLoader } from "../CustomLoader";
import { Accordion, AccordionSummary, AccordionDetails, useMediaQuery, useTheme } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { styled } from '@mui/material/styles';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PendingIcon from '@mui/icons-material/Pending';
import CancelIcon from '@mui/icons-material/Cancel';
import { commonToast } from "../common";
import "../common/commonPageStyles.css";
import {
  primaryButtonStyle,
  primaryButtonHoverColor,
} from "../common/commonButtonStyles";

function handleAmount(val) {
  const options = {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  };

  return (
    (Number(val) && Number(val).toLocaleString("en-US", options)) ||
    (val === 0 && parseInt(val).toFixed(2)) ||
    val
  );
}

export const inputStyleObj = {
  border: "2px solid #ccc",
  padding: 2,
  paddingLeft: 16,
  fontSize: 13,
  height: 38,
  width: "260px",
  borderRadius: 5,
};
export const selectStyleObj = {
  border: "1px solid #ccc",
  padding: 2,
  paddingLeft: 16,
  fontSize: 13,
  width: "100%",
  height: 38,
  borderRadius: 5,
};
export const filterInputStyleObj = {
  border: "2px solid #ccc",
  padding: 2,
  paddingLeft: 16,
  fontSize: 13,
  height: 38,
  width: "100%",
  borderRadius: 5,
};

export const buttonsFixations = {
  bottom: 15,
  left: 5,
  right: 0,
  backgroundColor: "white",
  borderTop: "1px solid #ddd",
  padding: "10px",
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end",
  gap: "10px",
  width: "98%",
  position: "absolute",
}

// export const errorSpanStyle = {
//   color: 'red',
//   fontSize: '14px',
//   fontWeight: 600,
//   marginTop: "1.5%",  
// }

const CustomTooltip = styled(Tooltip)({
  '& .MuiTooltip-tooltip': {
    backgroundColor: 'red !important',
  },
});

// Month mapping for display labels
const monthLabelMap = {
  "jan": "January",
  "feb": "February",
  "mar": "March",
  "apr": "April",
  "may": "May",
  "jun": "June",
  "jul": "July",
  "aug": "August",
  "sep": "September",
  "oct": "October",
  "nov": "November",
  "dec": "December",
};

const dialogStyle = {
  maxWidth: "95vw",
  width: "85vw",
  margin: "auto",
  maxHeight: "80vh",
};

const PremiumBDX = () => {
  const { search } = useLocation();
  const navigate = useNavigate();

  const policyNo = new URLSearchParams(search).get("policyNo");
  const fileName = new URLSearchParams(search).get("fileName");

  const { userData } = useSelector((state) => state?.user);

  const [selectedValue, setSelectedValue] = useState({});
  const [searchFieldsParams, setSearchFieldsParams] = useState({
    filename: [],
    month: [],
    year: [],
    lob: [],
  });
  
  // State for available filter options
  const [availableFileNames, setAvailableFileNames] = useState([]);
  const [availableLOBs, setAvailableLOBs] = useState([]);

  const [paginationCount, setPaginationCount] = useState(0);
  const [currentRow, setCurrentRow] = useState("");
  const [txnMode, setTxnMode] = useState("");

  const [isOpenAddFileDialog, setOpenAddFileDialog] = useState(false);
  const [isOpenViewDialog, setOpenViewDialog] = useState(false);

  const toggle = useSelector((state) => state.toggleSideMenu);
  const [fromDateValue, setFromDateValue] = useState("");
  const [toDateValue, setToDateValue] = useState("");

  const [isOpenWorkflowDialog, setIsOpenWorkflowDialog] = useState(false);

  const [filenameArray, setFilenameArray] = useState([]);
  const [certificateRefArray, setCertificateRefArray] = useState([]);

  const [isSearchPerformed, setIsSearchPerformed] = useState(false);
  const [isClearPerformed, setIsClearPerformed] = useState(false);
  const [filterSidebarOpen, setFilterSidebarOpen] = useState(true);
  const [availableYears, setAvailableYears] = useState([]);
  const [availableMonths, setAvailableMonths] = useState([]);
  const [yearMonthData, setYearMonthData] = useState([]);

  const handleMainCheckboxChange = (event) => {
    const { value } = event.target;
    const [filename, sheetname] = value.split('|');
    
    // Create a unique key based on filename and sheetname
    const key = `${filename}|${sheetname}`;

    // Toggle the selection
    setSelectedValue((prev) => ({
      ...prev,
      [key]: !prev[key], // Toggle the checked status
    }));
  };

  const currentSkipNumber = () => {
    return pageState?.page === 1
      ? 0
      : pageState?.page === 0
        ? pageState?.page
        : pageState?.page - 1;
  };

  const [pageState, setPageState] = useState({
    isLoading: false,
    data: [],
    total: 0,
    page: 1,
    pageSize: 25,
  });

  const [filenameToReplace, setFilenameToReplace] = useState(null);
  const [fileToUpload, setFileToUpload] = useState(null);
  const [excelFileSheetNames, setExcelFileSheetNames] = useState(null);
  const [selectedExcelSheetName, setSelectedExcelSheetName] = useState(null);
  const [selectedExcelSheetJson, setSelectedExcelSheetJson] = useState(null);
  const [currentTotalFNP, setCurrentTotalFNP] = useState(0);
  const [currentSelectedSheetRowCount, setCurrentSelectedSheetRowCount] = useState(0);
  const [sheetTabName, setSheetTabName] = useState("");
  const [bdxfileName, setBdxFileName] = useState("");
  const [commission, setCommission] = useState(0);
  const [open, setOpen] = useState(false);
  const [sheetNameToReplace, setSheetNameToReplace] = useState(null);
  const [isApiProgressBar, setIsApiProgressBar] = useState(false);
  const [isModelProgressBar, setIsModelProgressBar] = useState(false);

  const [isSubmitInProgress, setIsSubmitInProgress] = useState(false);

  //styles
  const classes = useStyles();

  const Container = {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    gap: 0,
    height: "calc(100vh - 180px)",
    maxHeight: "calc(100vh - 180px)",
    overflow: "hidden",
    backgroundColor: "#fafafa",
  };

  const handleRadioChange = (e) => {
    const isChecked = e.target.checked;
    setSelectedValue(isChecked ? e.target.value : "");
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    if (!value) {
      handleClearSearchList();
    }
    console.log("name", name, "value", value);
    setSearchFieldsParams((v) => ({
      ...v,
      [name]: value,
    }));
  };

  // Build query params for a single filter combination
  const buildQueryParams = (singleFilename, singleMonth, singleYear, singleLob) => {
    let queryParams = "";

    if (singleFilename) {
      queryParams = `${queryParams}&file_name=${encodeURIComponent(singleFilename)}`;
    }

    if (singleMonth) {
      const monthValue = singleMonth.substring(0, 3).toLowerCase();
      queryParams = `${queryParams}&month=${encodeURIComponent(monthValue)}`;
    }

    if (singleYear) {
      queryParams = `${queryParams}&year=${encodeURIComponent(singleYear)}`;
    }

    if (singleLob) {
      queryParams = `${queryParams}&lob=${encodeURIComponent(singleLob)}`;
    }

    if (fromDateValue && toDateValue) {
      let formattedFromDateValue = format(fromDateValue, "yyyy-MM-dd");
      let formattedToDateValue = format(toDateValue, "yyyy-MM-dd");
      queryParams = `${queryParams}&from_date=${formattedFromDateValue}&to_date=${formattedToDateValue}`;
    }

    return queryParams;
  };

  const handleSearchPaymentUpdatesList = async () => {
    try {
      setPageState((old) => ({ ...old, isLoading: true }));
      setIsSearchPerformed(true);
      setIsClearPerformed(false);

      const { filename, month, year, lob } = searchFieldsParams;
      
      // Convert to arrays if they're not already
      const filenames = Array.isArray(filename) ? filename : (filename ? [filename] : []);
      const months = Array.isArray(month) ? month : (month ? [month] : []);
      const years = Array.isArray(year) ? year : (year ? [year] : []);
      const lobs = Array.isArray(lob) ? lob : (lob ? [lob] : []);

      console.log("=== handleSearchPaymentUpdatesList ===");
      console.log("Filter values:", { filenames, months, years, lobs });

      // If no filters selected, use normal search
      if (filenames.length === 0 && months.length === 0 && years.length === 0 && lobs.length === 0) {
        let queryParams = `?skip=0&pageSize=${pageState?.pageSize}`;
        if (fromDateValue && toDateValue) {
          let formattedFromDateValue = format(fromDateValue, "yyyy-MM-dd");
          let formattedToDateValue = format(toDateValue, "yyyy-MM-dd");
          queryParams = `${queryParams}&from_date=${formattedFromDateValue}&to_date=${formattedToDateValue}`;
        }
        
        const response = await instance.get(`${premiumBDXFile}${queryParams}`);
        if (response.status === 200) {
          setPageState((old) => ({
            ...old,
            isLoading: false,
            total: response?.data?.count,
            data: response?.data?.data ?? [],
            page: 1,
          }));
          setPaginationCount(getPaginationCount(response?.data?.count || 0, pageState?.pageSize));
        }
        return;
      }

      // Generate all combinations of filter values
      // Use empty array to represent "no filter" for that field
      const filenameCombos = filenames.length > 0 ? filenames : [null];
      const monthCombos = months.length > 0 ? months : [null];
      const yearCombos = years.length > 0 ? years : [null];
      const lobCombos = lobs.length > 0 ? lobs : [null];

      // Generate all combinations
      const allCombinations = [];
      filenameCombos.forEach(f => {
        monthCombos.forEach(m => {
          yearCombos.forEach(y => {
            lobCombos.forEach(l => {
              allCombinations.push({ filename: f, month: m, year: y, lob: l });
            });
          });
        });
      });

      console.log("Total combinations to query:", allCombinations.length);

      // Make API calls for each combination
      const allResults = [];
      const seenIds = new Set();
      let maxCount = 0;

      for (const combo of allCombinations) {
        const queryParams = buildQueryParams(combo.filename, combo.month, combo.year, combo.lob);
        const fullQuery = `?skip=0&pageSize=${pageState?.pageSize}${queryParams}`;
        
        try {
          console.log("Querying with:", fullQuery);
          const response = await instance.get(`${premiumBDXFile}${fullQuery}`);
          
          if (response.status === 200 && response.data?.data) {
            // Add results that haven't been seen yet
            response.data.data.forEach(item => {
              if (!seenIds.has(item.id)) {
                seenIds.add(item.id);
                allResults.push(item);
              }
            });
            maxCount = Math.max(maxCount, response.data.count || 0);
          }
        } catch (error) {
          console.error("Error in combination query:", error);
        }
      }

      console.log("Total unique results:", allResults.length);
      console.log("Max count from API:", maxCount);

      setPageState((old) => ({
        ...old,
        isLoading: false,
        total: allResults.length, // Use actual unique count
        data: allResults,
        page: 1,
      }));
      setPaginationCount(getPaginationCount(allResults.length, pageState?.pageSize));
    } catch (error) {
      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));
      setPaginationCount(0);
      console.error("=== API ERROR ===");
      console.error("Error details:", error);
      console.error("Error response:", error?.response);
      console.error("Error message:", error?.message);
    }
  };

  const handleClearSearchList = async () => {
    setIsSearchPerformed(false);
    setIsClearPerformed(true);
    setSearchFieldsParams({
      filename: [],
      year: [],
      month: [],
      lob: [],
    });
    setFromDateValue("");
    setToDateValue("");
  };

  const isFilterBtnDisable = () => {
    let disabled = true;
    const { filename, month, year, lob } = searchFieldsParams;
    if (
      (Array.isArray(filename) && filename.length > 0) ||
      (Array.isArray(month) && month.length > 0) ||
      (Array.isArray(year) && year.length > 0) ||
      (Array.isArray(lob) && lob.length > 0) ||
      fromDateValue !== "" ||
      toDateValue !== ""
    ) {
      disabled = false;
    }
    return disabled;
  };

  const loadData = async () => {
    try {
      setPageState((old) => ({
        ...old,
        isLoading: true,
      }));

      let queryParams = ``;

      if (fileName) {
        queryParams = `${queryParams}&file_name=${fileName.replace(
          "&",
          "%26",
        )}`;
      }
      if (policyNo) {
        queryParams = `${queryParams}&Certificate_Ref=${policyNo}`;
      }

      // add search query param if the search is enabled
      // For pagination, use first value of each filter array
      if (isSearchPerformed) {
        const { filename, month, year, lob } = searchFieldsParams;
        const firstFilename = Array.isArray(filename) && filename.length > 0 ? filename[0] : (filename || null);
        const firstMonth = Array.isArray(month) && month.length > 0 ? month[0] : (month || null);
        const firstYear = Array.isArray(year) && year.length > 0 ? year[0] : (year || null);
        const firstLob = Array.isArray(lob) && lob.length > 0 ? lob[0] : (lob || null);
        
        const getSearchQueryParam = buildQueryParams(firstFilename, firstMonth, firstYear, firstLob);
        if (getSearchQueryParam) {
          queryParams = `${queryParams}${getSearchQueryParam}`;
        }
      }

      const response = await instance.get(
        `${premiumBDXFile}?skip=${currentSkipNumber()}&pageSize=${pageState?.pageSize
        }${queryParams}`,
      );

      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));

      if (response.status === 200) {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: response?.data?.data ?? [],
        }));
      } else {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: [],
        }));
        setPaginationCount(0);
      }
    } catch (err) {
      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));
      setPaginationCount(0);
      console.error("err", err);
    }
  };

  const downloadFile = async (currentRowData) => {
    let queryParams = `?`;
    let filename = currentRowData?.filename || "";
    let tab_name = currentRowData?.sheettab || "";
    if (filename) {
      queryParams = `${queryParams}&file_name=${filename.replace("&", "%26")}`;
    }
    if (tab_name) {
      queryParams = `${queryParams}&tab_name=${tab_name}`;
    }
    queryParams = `${queryParams}&action=download`;

    const response = await instance.get(`${premiumBDXFile}${queryParams}`);
    console.log("download response", response);
    const file_link = Object.values(response.data.Data)[0];
    console.log("file link", file_link);
    let link = document.createElement("a");
    console.log(link, "link123");
    link.href = file_link;
    link.click();
  };

  const handleActionButton = (currentRowData, currentTxnMode) => {
    setCurrentRow(currentRowData);
    setTxnMode(currentTxnMode);
    switch (currentTxnMode) {
      case "VIEW":
        setOpenViewDialog(true);
        handleGetFileToView(currentRowData);

        break;
      case "EDIT":
        setFilenameToReplace(currentRowData.filename);
        setSheetNameToReplace(currentRowData.sheettab);
        setOpenAddFileDialog(true);
        break;

      case "DELETE":
        console.log(currentRowData, "currentRowData123");
        setFilenameToReplace(currentRowData.filename);
        setOpen(true);
        break;

      case "DOWNLOAD":
        downloadFile(currentRowData);
        break;

      case "WORKFLOW":
        setIsOpenWorkflowDialog(true);
        break;

      default:
        break;
    }
  };

  const handleDeleteConfirmed = async () => {
    try {

      const response = await instance.delete(`${premiumBDX}?id=${currentRow?.id}&action=archieve&analyst_id=${userData.id}`);

      if (response.status === 200) {
        commonToast("success", `${currentRow?.filename} deleted successfully`);
        setOpen(false);
        setFilenameToReplace(null);
        setSheetNameToReplace(null);
        loadData();
      } else {
        commonToast("error", `Error deleting item: ${response.statusText}`);
        setOpen(false);
        setFilenameToReplace(null);
        setSheetNameToReplace(null);
      }
    } catch (error) {
      commonToast("error", `Error deleting item: ${error.message}`);
      setOpen(false);
      setFilenameToReplace(null);
      setSheetNameToReplace(null);
    }
  };

  const handleDeleteCancelled = () => {
    setOpen(false);
    setFilenameToReplace(null);
    setSheetNameToReplace(null);
  };

  const [isFileSelected, setIsFileSelected] = useState(false);
  const [filesData, setFilesData] = useState([]);
  const [fileSheetNamesMap, setFileSheetNamesMap] = useState({});
  const [selectedSheetNames, setSelectedSheetNames] = useState({});
  const [allFilesResponseData, setAllFilesResponseData] = useState([]);
  const allSheetsSelected = filesData.every(file => selectedSheetNames[file.name]);
  const [filesBinaryData, setFilesBinaryData] = useState({});


  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleInputFileChange = useCallback((e) => {
    const { name, files } = e.target;
    const allowedFormats = [
      "application/pdf",
      "text/csv",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];

    if (name === "file" && files.length > 0) {
      setIsFileSelected(true);
      const filesArray = Array.from(files);
      setFilesData(filesArray);
      for (let index = 0; index < filesArray.length; index++) {
        const file = filesArray[index];
        if (file && allowedFormats.includes(file.type)) {
          const reader = new FileReader();
          reader.onload = function (e) {
            var data = e.target.result;
            var workbookInner = read(data, { type: "binary" });
            var sheet_name_list = workbookInner.SheetNames;
            setFileSheetNamesMap(prevMap => ({
              ...prevMap,
              [file.name]: sheet_name_list
            }));
            // Store the binary data in state
            setFilesBinaryData(prevData => ({
              ...prevData,
              [file.name]: data
            }));
          };
          reader.readAsArrayBuffer(file);
        } else {
          alert("Invalid file format. Please select a PDF, CSV, or XLSX file.");
        }
      }
    }
  });

  const setHandleIntermediateView = async (selectedFile, selectedSheetName) => {
    try {
      setIsApiProgressBar(true);
      const form = new FormData();
      form.append("tab_name", selectedSheetName);
      form.append("file", selectedFile);
      form.append("analyst_id", userData.id);

      const response = await instance.post(`${premiumBDXReadData}`, form, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.status === 200) {
        setAllFilesResponseData(prevData => ({
          ...prevData,
          [selectedFile?.name]: {
            json: response.data.Response,
            total: response.data.total,
            count: response.data.count
          }
        }));
        setCurrentTotalFNP(response.data.total);
        setCurrentSelectedSheetRowCount(response.data.count);
        setSheetTabName(response.data.tab_name ?? "")
        setCommission(response.data.total_commission ?? 0)
        setSelectedExcelSheetJson(response.data.Response);
        setOpenViewDialog(true);
      } else {
        commonToast("error", `Error in retrieving file records`);
      }
    } catch (error) {
      console.log("error", error);
      commonToast("error", error?.data?.Error ?? `Error in retrieving file records`);
    } finally {
      setIsApiProgressBar(false);
    }
  };

  const handleGetFileToView = async (row) => {
    let queryParams = `?`;

    if (row?.filename) {
      queryParams = `${queryParams}file_name=${row?.filename.replace(
        "&",
        "%26",
      )}`;
    }
    if (row?.sheettab) {
      queryParams = `${queryParams}&tab_name=${row?.sheettab}`;
    }
    queryParams = `${queryParams}&action=view`;
    setIsApiProgressBar(true);
    try {
      const response = await instance.get(`${premiumBDXFile}${queryParams}`);
      setSelectedExcelSheetJson(response?.data?.Response);
      setCurrentTotalFNP(response.data.total);
      setCurrentSelectedSheetRowCount(response.data.count);
      setSheetTabName(response.data.tab_name ?? "")
      setBdxFileName(row?.filename)
      setCommission(response.data.total_commission ?? 0)
      setIsApiProgressBar(false);
    } catch (err) {
      setIsApiProgressBar(false);
      console.log("err", err);
    }
  };

  const handleSubmitFile = async () => {
    try {
      setIsSubmitInProgress(true);

      let payload = {
        action: "add",
        analyst_id: userData.id,
        comments: "automatic workflow initiated",
        initiateWF: true,
        response: selectedExcelSheetJson,
      };
      if (txnMode === "EDIT") {
        payload.action = "archieve";
        payload.old_file_name = filenameToReplace;
      } 

      const responseException = await instance.post(`${exceptionReport}`, payload);
      setIsSubmitInProgress(false);

      if (responseException.status === 200 || responseException.status === 201) {
        if (txnMode === "ADD") {
          commonToast("success", `${responseException.data.Message}`);
        } else {
          commonToast("success", `File ${txnMode === "ADD" ? "added" : "replaced"} successfully`);
        }

        setFileToUpload(null);
        setExcelFileSheetNames(null);
        setSelectedExcelSheetName(null);
        setSelectedExcelSheetJson(null);
        setOpenAddFileDialog(false);
        setFilesData([]);
        setSelectedSheetNames({});
        setOpenViewDialog(false);
        setFilenameToReplace(null);
        setSheetNameToReplace(null);
        setIsSubmitInProgress(false);

        // Navigate Exception Report
        navigate("/BDX/ExceptionReport");
      } else {
        setIsSubmitInProgress(false);
        commonToast("error", `Error ${txnMode === "ADD" ? "adding" : "replacing"} file`);
      }
    } catch (error) {
      console.log("error", error);
      setIsSubmitInProgress(false);
      commonToast("error", `Error ${txnMode === "ADD" ? "adding" : "replacing"} file: ${error.data.Response || ""
        }`);
    }
  };

  const columns = [
    {
      headerName: "",
      headerAlign: "center",
      flex: 0.1,
      type: "actions",
      renderCell: (params) => {
        const filename = params?.row?.filename;
        const sheetname = params?.row?.sheettab;
        const key = `${filename}|${sheetname}`;
        return (
          <>
            <Checkbox
              checked={!!selectedValue[key]}
              onChange={handleMainCheckboxChange}
              value={key}
              name="file-selection"
              style={{ color: "black" }}
            />
          </>
        );
      },
    },
    {
      field: "filename",
      headerName: "File Name",
      headerAlign: "center",
      flex: 1,
      minWidth: 500,
      renderCell: (params) => (
        <>
          <Tooltip title={params.row.filename}>
            <span style={{ textAlign: "left", display: "inline-block", width: "100%", marginLeft: "10px" }}>
              {params.row?.filename.length > 100 
                ? `${params.row.filename.substring(0, 100)}...` 
                : params.row.filename}
            </span>
          </Tooltip>
        </>
      ),
    },
    {
      field: "sheettab",
      headerName: "Sheet Name",
      headerAlign: "center",
      minWidth: 150,
      flex: 1,
    },
    {
      field: "month",
      headerName: "Month",
      headerAlign: "center",
      minWidth: 120,
      flex: 1,
    },
    {
      field: "year",
      headerName: "Year",
      headerAlign: "center",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "lob",
      headerName: "LOB",
      headerAlign: "center",
      minWidth: 150,
      flex: 1,
      renderCell: (params) => <>{params.row?.lob || "-"}</>,
    },
    {
      field: "total",
      headerName: "Final Net Settlement",
      headerAlign: "center",
      minWidth: 170,
      flex: 1,
      cellClassName: "amount-table-cell",
      renderCell: (params) => <>{handleAmount(params.row?.total)}</>,
    },
    {
      field: "commission_amount",
      headerName: "Commission Amount",
      headerAlign: "center",
      minWidth: 170,
      flex: 1,
      cellClassName: "amount-table-cell",
      renderCell: (params) => <>{handleAmount(params.row?.commission_amount)}</>,
    },
    {
      field: "count",
      headerName: "BDX Txn#",
      flex: 1,
      minWidth: 130,
      headerAlign: "center",
      renderCell: (params) => <>{params.row?.count}</>,
    },
    {
      field: "Analyst Name",
      headerName: "Analyst Name",
      flex: 1,
      minWidth: 150,
      headerAlign: "center",
      renderCell: (params) => <>{params.row["Analyst Name"]}</>,
    },
    {
      field: "processingdate",
      headerName: "Uploaded Date",
      flex: 1,
      minWidth: 150,
      headerAlign: "center",
      renderCell: (params) => (
        <>
          {dayjs(params.row?.processingdate, "YYYY-MM-DD").format("DD-MM-YYYY")}
        </>
      ),
    },
    {
      field: "error_message",
      headerName: "Error Log",
      flex: 1,
      minWidth: 300,
      headerAlign: "center",
      renderCell: (params) => (
        <>
          <Tooltip title={params.row.error_message || "No error"}>
            <span>
              {params.row.error_message 
                ? params.row.error_message.substring(0, 50) + (params.row.error_message.length > 50 ? "..." : "")
                : (params.row.upload_status ? "Uploaded" : "Uploading...")}
            </span>
          </Tooltip>
        </>
      ),
    },
    {
      field: "columns_not_found",
      headerName: "Columns Not Found",
      flex: 1,
      minWidth: 200,
      headerAlign: "center",
      renderCell: (params) => (
        <Tooltip title={params.row?.columns_not_found || ""}>
          <span>
            {params.row?.columns_not_found
              ? `${params.row.columns_not_found.substring(0, 40)}${params.row.columns_not_found.length > 40 ? "..." : ""}`
              : ""}
          </span>
        </Tooltip>
      ),
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 100,
      headerAlign: "center",
      renderCell: (params) => (
        <>
          {params.row?.upload_status ? (
            params.row?.is_prembdx_generated && params.row?.is_exception_generated 
            ? <CheckCircleIcon style={{ color: 'green' }} />
            : <CancelIcon style={{ color: 'red' }} />
          ) : (
            <PendingIcon style={{ color: 'grey' }} />
          )}
        </>
      ),
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 100,
      description: "This column has a value getter and is not sortable.",
      cellClassName: "actions",
      getActions: ({ row }) => {
        let actionsList = [];
        actionsList.push(
          <GridActionsCellItem
            icon={
              <Tooltip title="View">
                <ViewIcon />
              </Tooltip>
            }
            label="View"
            className="textPrimary"
            onClick={() => handleActionButton(row, "VIEW")}
            color="inherit"
            disabled={!row.upload_status || !row.is_prembdx_generated}
          />,
        );
        
        actionsList.push(
          <GridActionsCellItem
            icon={
              <Tooltip title="Edit">
                <EditIcon />
              </Tooltip>
            }
            className="textPrimary"
            label="Edit"
            onClick={() => handleActionButton(row, "EDIT")}
            color="inherit"
          />,
        );

        actionsList.push(
          <GridActionsCellItem
            icon={
              <Tooltip title="Delete">
                <DeleteIcon />
              </Tooltip>
            }
            label="delete"
            className="textPrimary"
            onClick={() => handleActionButton(row, "DELETE")}
            color="inherit"
            disabled={!row.upload_status}
          />,
        );

        // actionsList.push(
        //   <GridActionsCellItem
        //     icon={
        //       <Tooltip title="Download">
        //         <DownloadIcon className="action-icon" />
        //       </Tooltip>
        //     }
        //     label="download"
        //     className="textPrimary"
        //     onClick={() => handleActionButton(row, "DOWNLOAD")}
        //     color="inherit"
        //   />,
        // );

        return actionsList;
      },
    },
  ];

  const handleFileSave = async () => {
    try {
      setIsModelProgressBar(true);
      await Promise.all(selectedFiles.map(async (file) => {
        const form = new FormData();
        form.append("tab_name", selectedSheetNames[file?.name]);
        form.append("file", file);
        form.append("analyst_id", userData.id);
        form.append("action", "parse");
        if (txnMode === "EDIT") {
          await instance.delete(`${premiumBDX}?id=${currentRow?.id}&action=archieve&analyst_id=${userData.id}`);
        }
  
        const response = await instance.post(`${premiumBDX}`, form, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
  
        // if (response.status === 400) {
        //   const errorMessage = response.data?.message || "An error occurred";
        //   console.error("API Error:", errorMessage);
        //   toast.error(errorMessage, {
        //     position: toast.POSITION.TOP_RIGHT,
        //     autoClose: 1000,
        //   });
        // } else if (response.status === 200) {
        //   setAllFilesResponseData(prevData => ({
        //     ...prevData,
        //     [file.name]: { // Ensure to use file.name as the key
        //       json: response.data.Response,
        //       total: response.data.total,
        //       count: response.data.count
        //     }
        //   }));
        //   setSelectedExcelSheetJson(response.data.Response);
        //   setOpenAddFileDialog(false);
        //   loadData();
        // } else {
        //   toast.error(`Error in retrieving file records`, {
        //     position: toast.POSITION.TOP_RIGHT,
        //     autoClose: 1000,
        //   });
        // }
      }));
    } catch (error) {
      console.log("error", error);
      // toast.error(error?.data?.Response ?? `Error in retrieving file records`, {
      //   position: toast.POSITION.TOP_RIGHT,
      //   autoClose: 1000,
      // });
    } finally {
      setIsModelProgressBar(false);
      setSelectedFiles([]);
      setSelectedExcelSheetJson(null);
      setAllFilesResponseData({});
      setOpenAddFileDialog(false);
      setFilesData([]);
      setSelectedSheetNames({});
      loadData();
      commonToast("success", "Record added successfully");
    }
  }

  useEffect(() => {
    setPaginationCount(
      getPaginationCount(pageState?.total, pageState?.pageSize),
    );
  }, [pageState?.pageSize, pageState?.total]);

  // Fetch available years, months, LOBs, and file names from existing API data
  useEffect(() => {
    const fetchFilterData = async () => {
      try {
        // Fetch all data without filters to get all available filter options
        const response = await instance.get(`${premiumBDXFile}?skip=0&pageSize=10000`);
        if (response.status === 200 && response.data && response.data.data) {
          const allData = response.data.data;
          
          // Extract unique years and months from the data
          const yearMonthMap = {};
          const allMonthsSet = new Set();
          const fileNamesSet = new Set();
          const lobsSet = new Set();
          
          console.log("=== Fetching Filter Data ===");
          console.log("Total items fetched:", allData.length);
          
          allData.forEach(item => {
            const year = item.year;
            const month = item.month;
            const filename = item.filename;
            const lob = item.lob;
            
            if (year && month) {
              // Group months by year - preserve original case from database
              if (!yearMonthMap[year]) {
                yearMonthMap[year] = new Set();
              }
              // Store month as-is from database (could be lowercase like "nov" or uppercase)
              yearMonthMap[year].add(month);
              allMonthsSet.add(month);
            }
            
            if (filename) {
              fileNamesSet.add(filename);
            }
            
            if (lob) {
              lobsSet.add(lob);
            }
          });
          
          console.log("Year-Month Map:", yearMonthMap);
          console.log("All months set:", Array.from(allMonthsSet));
          console.log("File names set:", Array.from(fileNamesSet));
          console.log("LOBs set:", Array.from(lobsSet));
          
          // Convert to array format for yearMonthData (keep year as string for consistency)
          const yearMonthArray = Object.keys(yearMonthMap).map(year => ({
            year: year.toString(), // Ensure year is string
            months: Array.from(yearMonthMap[year]).sort()
          })).sort((a, b) => parseInt(b.year) - parseInt(a.year));
          
          setYearMonthData(yearMonthArray);
          console.log("Year-Month Array:", yearMonthArray);
          
          // Extract unique years (sorted descending) - keep as strings to match yearMonthData
          const years = Object.keys(yearMonthMap).map(y => y.toString()).sort((a, b) => parseInt(b) - parseInt(a));
          setAvailableYears(years);
          console.log("Available years:", years);
          
          // Extract unique months (sorted)
          const monthsArray = Array.from(allMonthsSet).sort();
          setAvailableMonths(monthsArray);
          console.log("Available months:", monthsArray);
          
          // Extract unique file names (sorted)
          const fileNamesArray = Array.from(fileNamesSet).sort();
          setAvailableFileNames(fileNamesArray);
          console.log("Available file names:", fileNamesArray);
          
          // Extract unique LOBs (sorted)
          const lobsArray = Array.from(lobsSet).sort();
          setAvailableLOBs(lobsArray);
          console.log("Available LOBs:", lobsArray);
        }
      } catch (error) {
        console.error("Error fetching filter data:", error);
      }
    };
    
    fetchFilterData();
  }, []);

  // UseEffect
  useEffect(() => {
    if (isClearPerformed) {
      loadData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isClearPerformed]);

  useEffect(() => {
    if (!isClearPerformed) {
      loadData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageState?.pageSize, pageState?.page]);

  // State to track loading status for each file
  const [loadingStates, setLoadingStates] = useState(new Map());

  // Function to handle view action
  const handleView = useCallback((file, sheetName) => {
    // Set loading true for the specific file and sheet
    setLoadingStates(prev => new Map(prev).set(`${file.name}-${sheetName}`, true));
    
    setHandleIntermediateView(file, sheetName)
      .finally(() => {
        // Set loading false for the specific file and sheet
        setLoadingStates(prev => {
          const newStates = new Map(prev);
          newStates.set(`${file.name}-${sheetName}`, false);
          return newStates;
        });
      });
  }, [setHandleIntermediateView]);

  // Add a state to track selected files
  const [selectedFiles, setSelectedFiles] = useState([]);

  // Checkbox change handler
  const handleCheckboxChange = (file, isChecked) => {
    setSelectedFiles(prev => {
      if (isChecked) {
        return [...prev, file]; // Add file to the list
      } else {
        return prev.filter(f => f.name !== file.name); // Remove file from the list
      }
    });
  };

  const handleEnter = (e) => {
    if (e.code === "Enter") {
      handleSearchPaymentUpdatesList();
    }
  };

  // Get months available for selected year(s), or all months if no year selected
  const getAvailableMonthsForYear = () => {
    console.log("=== getAvailableMonthsForYear ===");
    console.log("Selected year(s):", searchFieldsParams.year);
    console.log("Available months:", availableMonths);
    console.log("Year-Month data:", yearMonthData);
    
    // If no year selected, return all available months
    if (!searchFieldsParams.year || (Array.isArray(searchFieldsParams.year) && searchFieldsParams.year.length === 0)) {
      const result = availableMonths.length > 0 ? availableMonths : [];
      console.log("No year selected, returning all months:", result);
      return result;
    }
    
    // Handle array of selected years
    const selectedYears = Array.isArray(searchFieldsParams.year) 
      ? searchFieldsParams.year.map(y => y.toString())
      : [searchFieldsParams.year.toString()];
    
    const monthsSet = new Set();
    selectedYears.forEach(selectedYear => {
      const yearData = yearMonthData.find(item => item.year === selectedYear || item.year.toString() === selectedYear);
      if (yearData && yearData.months && yearData.months.length > 0) {
        yearData.months.forEach(month => monthsSet.add(month));
      }
    });
    
    if (monthsSet.size > 0) {
      const result = Array.from(monthsSet).sort();
      console.log("Returning months for selected years:", selectedYears, ":", result);
      return result;
    }
    
    // Fallback: return all months if year data not found
    const result = availableMonths.length > 0 ? availableMonths : [];
    console.log("Year data not found, returning all months:", result);
    return result;
  };

  // Prepare filter configs for CommonFilterSidebar
  const filterConfigs = [
    {
      type: "bankName", // Using bankName type for multi-select checkbox
      label: "Year",
      placeholder: "Search Year",
      items: availableYears,
      selectedItems: Array.isArray(searchFieldsParams.year) ? searchFieldsParams.year.map(y => y.toString()) : [],
      searchValue: "",
      onSearchChange: () => {}, // No search for years
      onItemChange: (yearValue) => {
        const currentYears = Array.isArray(searchFieldsParams.year) ? searchFieldsParams.year : [];
        const yearStr = yearValue.toString();
        if (currentYears.includes(yearStr)) {
          setSearchFieldsParams((v) => ({
            ...v,
            year: currentYears.filter(y => y.toString() !== yearStr),
          }));
        } else {
          setSearchFieldsParams((v) => ({
            ...v,
            year: [...currentYears, yearStr],
          }));
        }
      },
      onClear: () => {
        setSearchFieldsParams((v) => ({
          ...v,
          year: [],
        }));
      },
    },
    {
      type: "bankName", // Using bankName type for multi-select checkbox
      label: "Month",
      placeholder: "Search Month",
      items: getAvailableMonthsForYear().map(monthValue => {
        const monthKey = monthValue.toLowerCase();
        const label = monthLabelMap[monthKey] || monthValue.charAt(0).toUpperCase() + monthValue.slice(1).toLowerCase();
        // Store just the label for display, but we'll map it back to value when selected
        return label;
      }),
      selectedItems: Array.isArray(searchFieldsParams.month) 
        ? searchFieldsParams.month.map(m => {
            const monthKey = m.toLowerCase();
            const label = monthLabelMap[monthKey] || m.charAt(0).toUpperCase() + m.slice(1).toLowerCase();
            return label;
          })
        : [],
      searchValue: "",
      onSearchChange: () => {}, // No search for months
      onItemChange: (labelStr) => {
        // Convert label back to abbreviation
        const reverseMonthMap = {
          "january": "jan", "february": "feb", "march": "mar", "april": "apr",
          "may": "may", "june": "jun", "july": "jul", "august": "aug",
          "september": "sep", "october": "oct", "november": "nov", "december": "dec"
        };
        const monthValue = reverseMonthMap[labelStr.toLowerCase()] || labelStr.substring(0, 3).toLowerCase();
        const currentMonths = Array.isArray(searchFieldsParams.month) ? searchFieldsParams.month : [];
        if (currentMonths.includes(monthValue)) {
          setSearchFieldsParams((v) => ({
            ...v,
            month: currentMonths.filter(m => m !== monthValue),
          }));
        } else {
          setSearchFieldsParams((v) => ({
            ...v,
            month: [...currentMonths, monthValue],
          }));
        }
      },
      onClear: () => {
        setSearchFieldsParams((v) => ({
          ...v,
          month: [],
        }));
      },
    },
    {
      type: "bankName", // Using bankName type for multi-select checkbox
      label: "LOB",
      placeholder: "Search LOB",
      items: availableLOBs,
      selectedItems: Array.isArray(searchFieldsParams.lob) ? searchFieldsParams.lob : [],
      searchValue: "",
      onSearchChange: () => {}, // Can add search functionality later if needed
      onItemChange: (lobValue) => {
        const currentLobs = Array.isArray(searchFieldsParams.lob) ? searchFieldsParams.lob : [];
        if (currentLobs.includes(lobValue)) {
          setSearchFieldsParams((v) => ({
            ...v,
            lob: currentLobs.filter(l => l !== lobValue),
          }));
        } else {
          setSearchFieldsParams((v) => ({
            ...v,
            lob: [...currentLobs, lobValue],
          }));
        }
      },
      onClear: () => {
        setSearchFieldsParams((v) => ({
          ...v,
          lob: [],
        }));
      },
    },
    {
      type: "bankName", // Using bankName type for multi-select checkbox
      label: "File Name",
      placeholder: "Search File Name",
      items: availableFileNames,
      selectedItems: Array.isArray(searchFieldsParams.filename) ? searchFieldsParams.filename : [],
      searchValue: "",
      onSearchChange: () => {}, // Can add search functionality later if needed
      onItemChange: (filenameValue) => {
        const currentFilenames = Array.isArray(searchFieldsParams.filename) ? searchFieldsParams.filename : [];
        if (currentFilenames.includes(filenameValue)) {
          setSearchFieldsParams((v) => ({
            ...v,
            filename: currentFilenames.filter(f => f !== filenameValue),
          }));
        } else {
          setSearchFieldsParams((v) => ({
            ...v,
            filename: [...currentFilenames, filenameValue],
          }));
        }
      },
      onClear: () => {
        setSearchFieldsParams((v) => ({
          ...v,
          filename: [],
        }));
      },
    },
    {
      type: "dateRange",
      label: "Date Range",
      startDate: fromDateValue,
      setStartDate: setFromDateValue,
      endDate: toDateValue,
      setEndDate: setToDateValue,
      maxDate: new Date(),
      onKeyUp: handleEnter,
    },
  ];

  return (
    <div style={Container}>
      {/* Filter Sidebar */}
      <CommonFilterSidebar
        isOpen={filterSidebarOpen}
        filterConfigs={filterConfigs}
        onApplyFilters={handleSearchPaymentUpdatesList}
        onClearFilters={handleClearSearchList}
        isLoading={pageState?.isLoading}
        isFilterDisabled={isFilterBtnDisable()}
      />

      {/* Main Content Area */}
      <Box className="main-content-area">
        <Box className="page-header-container">
          <Typography
            variant="h5"
            className="page-heading"
          >
            Premium BDX
          </Typography>
          <Box sx={{ display: "flex", gap: "12px", alignItems: "center" }}>
            <CommonButton
              text="Add"
              handleClick={() => {
                setTxnMode("ADD");
                setOpenAddFileDialog(true);
              }}
              sx={primaryButtonStyle}
              hoverColor={primaryButtonHoverColor}
              disabled={pageState?.isLoading}
            />
            <IconButton
              onClick={() => setFilterSidebarOpen(!filterSidebarOpen)}
              className="filter-toggle-button"
            >
              <FilterListIcon />
            </IconButton>
          </Box>
        </Box>

        <Box
          sx={{
            flex: 1,
          display: "flex",
            flexDirection: "column",
            minHeight: 0,
            position: "relative",
            backgroundColor: "#ffffff",
            borderRadius: "12px",
            boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
            overflow: "visible",
            transition: "all 0.3s ease",
            border: "1px solid #e8eaf0",
            paddingBottom: "10px",
            "&:hover": {
              boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
            },
        }}
      >
        <DataGrid
          className={classes.pagination}
          loading={pageState?.isLoading}
          rows={pageState?.data ?? []}
          getRowId={(row) => pageState?.data.indexOf(row)}
          rowCount={pageState?.total}
          columns={columns}
          keepNonExistentRowsSelected
          pagination
          paginationMode="server"
          disableSelectionOnClick
          page={pageState.page - 1}
          pageSize={pageState?.pageSize ?? 25}
            rowsPerPageOptions={[10, 25, 50, 100]}
          onPageSizeChange={(newPageSize) => {
            return setPageState((old) => {
              setPaginationCount(
                getPaginationCount(pageState?.total, newPageSize),
              );
              return { ...old, pageSize: newPageSize, page: 1 };
            });
          }}
          sx={{
              border: "none",
              flex: 1,
              minHeight: 0,
              "& .MuiDataGrid-root": {
                border: "none",
                height: "100%",
              },
              "& .MuiDataGrid-main": {
                height: "100%",
                "&::-webkit-scrollbar": {
                  width: "8px",
                  height: "8px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#1672DE",
                  borderRadius: "10px",
                  "&:hover": {
                    background: "#1565c0",
                  },
                },
              },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#f8f9fa",
                borderBottom: "2px solid #e0e0e0",
                minHeight: "52px !important",
                maxHeight: "52px !important",
              },
              "& .MuiDataGrid-columnHeader": {
                backgroundColor: "transparent",
                fontWeight: "600",
                color: "#1672DE",
                fontSize: "14px",
                padding: "12px 16px",
                borderBottom: "none",
                "&:focus": {
                  outline: "none",
                },
                "&:focus-within": {
                  outline: "none",
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  fontWeight: "600",
                  fontSize: "14px",
                },
                "& .MuiDataGrid-sortIcon": {
                  color: "#1672DE",
                },
                "& .MuiDataGrid-menuIcon": {
                  color: "#1672DE",
                },
              },
              "& .MuiDataGrid-row": {
                transition: "all 0.2s ease",
                borderBottom: "1px solid #f0f0f0",
                "&:hover": {
                  backgroundColor: "rgba(22, 114, 222, 0.04)",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
                },
                "&.Mui-selected": {
                  backgroundColor: "rgba(22, 114, 222, 0.08)",
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 222, 0.12)",
                  },
                },
                "&:nth-of-type(even)": {
                  backgroundColor: "#fafafa",
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 222, 0.04)",
                  },
                },
              },
              "& .MuiDataGrid-cell": {
                borderBottom: "1px solid #f0f0f0",
                padding: "12px 16px",
                fontSize: "13px",
                color: "#333",
                display: "flex",
                alignItems: "center",
                "&:focus": {
                  outline: "none",
                },
                "&:focus-within": {
                  outline: "none",
                },
              },
              "& .MuiDataGrid-virtualScroller": {
                "&::-webkit-scrollbar": {
                  width: "8px",
                  height: "8px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#1672DE",
                  borderRadius: "10px",
                  "&:hover": {
                    background: "#1565c0",
                  },
                },
              },
              "& .MuiDataGrid-footerContainer": {
                borderTop: "2px solid #e0e0e0",
                backgroundColor: "#f8f9fa",
                minHeight: "48px",
                maxHeight: "48px",
                paddingBottom: "8px",
                paddingTop: "8px",
                paddingLeft: "16px",
                paddingRight: "16px",
                position: "relative",
                zIndex: 1,
                "& .MuiTablePagination-root": {
                  color: "#666",
                  paddingRight: "16px",
                  margin: 0,
                  minHeight: "32px",
                },
                "& .MuiTablePagination-selectLabel": {
                  fontSize: "13px",
                  margin: 0,
                },
                "& .MuiTablePagination-displayedRows": {
                  fontSize: "13px",
                  margin: 0,
                },
                "& .MuiTablePagination-actions": {
                  marginLeft: "8px",
                  "& .MuiIconButton-root": {
                    padding: "4px",
                  },
                },
                "& .MuiTablePagination-select": {
                  margin: "0 8px",
                  padding: "4px 8px",
                },
                "& .MuiTablePagination-toolbar": {
                  minHeight: "32px",
                  padding: 0,
                },
              },
              "& .MuiDataGrid-toolbarContainer": {
                padding: "12px 16px",
                backgroundColor: "#f8f9fa",
                borderBottom: "1px solid #e0e0e0",
                "& .MuiButton-root": {
                  color: "#1672DE",
                  fontSize: "13px",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 222, 0.1)",
                  },
                },
              },
              "& .MuiDataGrid-loadingOverlay": {
                backgroundColor: "rgba(255, 255, 255, 0.8)",
            },
          }}
          components={{
            Toolbar: GridToolbarContainer,
            NoRowsOverlay: () => (
                <Stack
                  height="100%"
                  alignItems="center"
                  justifyContent="center"
                  sx={{ color: "#999" }}
                >
                  <Typography variant="body2" sx={{ color: "#999" }}>
                No Uploaded Files
                  </Typography>
              </Stack>
            ),
          }}
        />
        <Stack
            sx={{
            position: "absolute",
              bottom: "16px",
              right: "20px",
              zIndex: 10,
              backgroundColor: "#f8f9fa",
              padding: "4px 8px",
              borderRadius: "4px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          <CommonPaginationContainer
            count={paginationCount + 1}
            pageState={pageState}
            setPageState={setPageState}
          />
        </Stack>
        </Box>
      </Box>

      <Dialog
        open={isOpenAddFileDialog}
        disableBackdropClick
        disableEscapeKeyDown
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        PaperProps={{ style: dialogStyle }}
      >
        { isModelProgressBar && <CustomLoader />}
        <DialogTitle id="alert-dialog-title" sx={{ cursor: "default" }}>
          {txnMode === "ADD"
            ? "Add File"
            : txnMode === "EDIT"
              ? "Replace File"
              : null}
          <IconButton
            aria-label="close"
            onClick={() => {
              setOpenAddFileDialog(false);
              setFilesData([]);
              setSelectedSheetNames({});
              setOpenViewDialog(false);
              setFileToUpload(null);
              setExcelFileSheetNames(null);
              setSelectedExcelSheetName(null);
              setSelectedExcelSheetJson(null);
            }}
            style={{ position: "absolute", right: 12, top: 12 }}
          >
            <CloseIcon className="CloseIconStyle" />
          </IconButton>
          <hr style={{ width: "100%" }} />
        </DialogTitle>
        <DialogContent
          sx={{
            padding: "0px 24px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Grid item xs={12} sx={{ margin: "10px 0px", display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
            <Button
              color="primary"
              variant="contained"
              component="label"
              style={{ 
                height: "32px", 
                fontWeight: 600,
                backgroundColor: "#1672DE",
                color: "white",
                fontSize: "12px",
                padding: "6px 12px",
                minWidth: "auto"
              }}
            >
              {txnMode === "ADD"
                ? "Select New File to Upload"
                : txnMode === "EDIT"
                  ? "Select File to Replace"
                  : null}
              <input
                type="file"
                hidden
                name="file"
                accept=".doc,.docx,.xlsx,.csv,.pdf"
                onChange={(e) => {
                  setFilesData([]);
                  setSelectedSheetNames({});
                  handleInputFileChange(e);
                }}
                multiple
                required
              />
            </Button>
            <CommonButton
              text="Save"
              handleClick={() =>
                filesData.length > 0 ? handleFileSave() : null
              }
              disabled={
                filesData.length === 0 || 
                selectedFiles.length === 0 || 
                selectedFiles.some(file => !(selectedSheetNames[file.name] && selectedSheetNames[file.name].length > 0))
              }
              hoverColor="#1565c0"
              style={{
                backgroundColor: (filesData.length === 0 || 
                  selectedFiles.length === 0 || 
                  selectedFiles.some(file => !(selectedSheetNames[file.name] && selectedSheetNames[file.name].length > 0))) ? "#CCCCCC" : "#1672DE",
                color: "white",
                borderRadius: "6px",
                padding: "6px 12px",
                fontWeight: "500",
                fontSize: "12px",
                transition: "all 0.3s ease",
                boxShadow: (filesData.length === 0 || 
                  selectedFiles.length === 0 || 
                  selectedFiles.some(file => !(selectedSheetNames[file.name] && selectedSheetNames[file.name].length > 0))) ? "none" : "0 2px 4px rgba(22, 114, 222, 0.2)",
              }}
            />
          </Grid>
          <Grid item xs={12} sx={{ margin: "10px 0px" }}>
            {filesData.length > 0 && (
              filesData.map((file, index) => (
                <>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: 'space-between',
                    marginBottom: "15px"
                  }}
                  key={index}
                > 
                  <Checkbox
                    checked={selectedFiles.some(f => f.name === file.name)}
                    onChange={(e) => handleCheckboxChange(file, e.target.checked)}
                  />
                  <CustomTooltip title={file.name}>
                    <span style={{ fontSize: "14px", fontWeight: 600, paddingTop: "1.5%" }}>
                      {file.name.length > 70 ? `${file.name.substring(0, 70)}...` : file.name} - Size: {file.size}
                    </span>
                  </CustomTooltip>
                  {fileSheetNamesMap[file.name] && 
                    <Card
                      elevation={5}
                      sx={{ marginTop: "5px", overflow: "auto !important" }}
                    >
                      <div>
                        <FormControl fullWidth style={{ width: '250px' }}>
                          <Select
                            labelId={`select-label-${file.name}`}
                            multiple
                            value={selectedSheetNames[file.name] || []}
                            onChange={(e) => {
                              const value = e.target.value;
                              // Set the selected sheet names to the new selection
                              setSelectedSheetNames(prev => ({
                                ...prev,
                                [file.name]: typeof value === 'string' ? value.split(',') : value,
                              }));
                            }}
                            displayEmpty
                            renderValue={selected => (
                              <Tooltip title={selected.join(', ') || 'No sheets selected'}>
                                <span>{selected.length > 0 ? selected.join(', ') : 'Please select sheet'}</span>
                              </Tooltip>
                            )}
                            MenuProps={{
                              PaperProps: {
                                style: {
                                  maxHeight: 48 * 4.5 + 8,
                                  width: 250,
                                },
                              },
                            }}
                          >
                            {fileSheetNamesMap[file.name].map((sheetName, index) => (
                              <MenuItem key={index} value={sheetName}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                  <Checkbox checked={(selectedSheetNames[file.name] || []).indexOf(sheetName) > -1} />
                                  <ListItemText primary={sheetName} />
                                  <IconButton
                                    onClick={(e) => {
                                      e.stopPropagation(); // Prevent the select from closing
                                      handleView(file, sheetName);
                                    }}
                                    size="small"
                                  >
                                    {loadingStates.get(`${file.name}-${sheetName}`) ? <CustomLoader /> : <VisibilityIcon fontSize="small" />}
                                  </IconButton>
                                </div>
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                    </Card>
                  }
                  {/* <Button 
                    style={{ marginTop: "1.5%" }}
                    onClick={() =>
                      filesData.length > 0 ? setHandleIntermediateView(file) : null
                    }
                    disabled={!selectedSheetNames[file.name]}
                  >View</Button> */}
                  {/* <span style={{ ...errorSpanStyle }}>Error</span> */}
                  {/* <Button style={{ marginTop: "1.5%" }} onClick={() => {
                    setSelectedSheetNames(prev => ({
                      ...prev,
                      [file.name]: null
                    }));
                    setFilesData(prevFiles => prevFiles.filter(f => f.name !== file.name));
                  }}>Remove File</Button> */}
                </div>
              </>
              ))
            )}
          </Grid>
          {/* { isApiProgressBar && <CustomLoader />} */}
        </DialogContent>
      </Dialog>
      <Dialog
        open={isOpenViewDialog}
        disableBackdropClick
        disableEscapeKeyDown
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        PaperProps={{ style: dialogStyle }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ cursor: "default", position: "relative" }}
        >
          {"View File"}
          <IconButton
            aria-label="close"
            onClick={() => {
              setOpenViewDialog(false);
              if (txnMode === "VIEW") {
                setSelectedExcelSheetJson(null);
              }
            }}
            style={{ position: "absolute", right: 12, top: 12 }}
          >
            <CloseIcon className="CloseIconStyle" />
          </IconButton>
          <hr style={{ width: "100%" }} />
        </DialogTitle>
        <DialogContent
          sx={{
            padding: "30px 30px 30px 30px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "100%" 
          }}
        >
          <Grid lg={12} display={"flex"} flexDirection={"column"}>
            {isApiProgressBar && <CustomLoader />}
            <Grid
              xs={12}
              lg={12}
              gap={1}
              container
              className="ViewpageContainerItems"
            >
              <GetViewTable
                selectedExcelSheetJson={selectedExcelSheetJson}
                setSelectedExcelSheetJson={setSelectedExcelSheetJson}
                setFilenameArray={setFilenameArray}
                setCertificateRefArray={setCertificateRefArray}
                currentTotalFNP={currentTotalFNP}
                currentSelectedSheetRowCount={currentSelectedSheetRowCount}
                sheetTabName={sheetTabName}
                bdxfileName={bdxfileName}
                commission={commission}
                allFilesResponseData={allFilesResponseData}
              />
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
      <Dialog
        open={isOpenWorkflowDialog}
        onClose={() => setIsOpenWorkflowDialog(false)}
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            maxWidth: "500px",
          },
        }}
      >
        {currentRow.certificateref === "PCY2812924AD" ? (
          <div>
            <DialogTitle id="alert-dialog-title" sx={{ cursor: "default" }}>
              {"Workflow Initiated"}
              <IconButton
                aria-label="close"
                onClick={() => {
                  setIsOpenWorkflowDialog(false);
                }}
                style={{ position: "absolute", right: 12, top: 12 }}
              >
                <CloseIcon className="CloseIconStyle" />
              </IconButton>
              <hr style={{ width: "100%" }} />
            </DialogTitle>
            <DialogContent
              sx={{
                padding: "0px 24px 5px 24px",
                display: "flex",
                fontSize: "12px",
              }}
            >
              <Grid
                lg={12}
                display={"flex"}
                flexDirection={"column"}
                backgroundColor={"rgb(175, 171, 170)"}
              >
                <Grid
                  item
                  xs={12}
                  md={6}
                  marginBottom={2}
                >
                  <div>Workflow Name : NO_VARIANCE_WORKFLOW</div>
                  <div>Workflow Status : In Process</div>
                  <div>Current Step : reviewer</div>
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={6}
                  marginBottom={2}
                >
                  <div>Step Name : initiater</div>
                  <div>Initiator Comments :</div>
                  <div>Initiator Name : vijay kumar reddy</div>
                  <div>Date/Time : 2024-06-21 12:40:01.251541</div>
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={6}
                  marginBottom={2}
                >
                  <div>Step Name : reviewer</div>
                  <div>Reviewer Comments :</div>
                  <div>
                    Reviewer Name : Rupesh, lrname, Reviewer0, Shivali123
                  </div>
                  <div>Date/Time :</div>
                  <div>Status :</div>
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={6}
                  marginBottom={2}
                >
                  <div>Step Name : approver</div>
                  <div>Approver Comments :</div>
                  <div>
                    Approver Name : Test Treasury, maname, sairam, Kerry Fenn,
                    Approver0
                  </div>
                  <div>Date/Time :</div>
                  <div>Status :</div>
                </Grid>
              </Grid>
            </DialogContent>
          </div>
        ) : (
          <div>
            <DialogTitle id="alert-dialog-title" sx={{ cursor: "default" }}>
              {"Workflow Not Initiated"}
              <IconButton
                aria-label="close"
                onClick={() => {
                  setIsOpenWorkflowDialog(false);
                }}
                style={{ position: "absolute", right: 12, top: 12 }}
              >
                <CloseIcon className="CloseIconStyle" />
              </IconButton>
              <hr style={{ width: "100%" }} />
            </DialogTitle>
            <DialogContent
              sx={{
                padding: "0px 24px 5px 24px",
                display: "flex",
                fontSize: "12px",
              }}
            >
              <Grid
                lg={12}
                display={"flex"}
                flexDirection={"column"}
                backgroundColor={"rgb(175, 171, 170)"}
              ></Grid>
              There is variance in data. Please check Exception report or upload
              updated Premium BDX File.
            </DialogContent>
          </div>
        )}
      </Dialog>
      <DialogBox
        title="Delete Confirmation"
        body="Are you sure you want to delete this item? If there are multiple files associated with this file name, all those will be deleted."
        confirmText="Delete"
        isOpen={open}
        onCancel={handleDeleteCancelled}
        onConfirm={handleDeleteConfirmed}
      />
    </div>
  );
};

export default PremiumBDX;
